import { MessageCircle } from 'lucide-react';
import { openWhatsApp } from '@/utils/whatsapp';

interface WhatsAppHelpProps {
  productName?: string;
}

export const WhatsAppHelp = ({ productName }: WhatsAppHelpProps) => {
  const handleClick = () => {
    const message = productName
      ? `Hi! I have a question about "${productName}". Can you help?`
      : 'Hi! I need help choosing a plant. Can you assist me?';
    openWhatsApp('918360249017', message);
  };

  return (
    <button
      onClick={handleClick}
      className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-primary transition-colors"
    >
      <MessageCircle className="h-3.5 w-3.5" />
      <span>Need help? Chat with us</span>
    </button>
  );
};
